
/**
 * Отримання поточного стану онбордингу
 */
export function getOnboarding() {
  return axios({
    url: '/api/onboarding',
    method: 'get',
  });
}

/**
 * Збереження чернетки (шаг + дані форми)
 * @param {Object} data - { step: 1, data: { ... } }
 */
export function saveOnboardingDraft(data) {
  return axios({
    url: '/api/onboarding/save',
    method: 'post',
    data,
  });
}

/**
 * Завантаження одного документа
 * @param {string} type - ключ документа (наприклад 'tax_cert', 'bank_statement')
 * @param {File} file - об'єкт файлу з input
 */
export function uploadOnboardingDocument(type, file) {
  let formData = new FormData();
  formData.append('type', type);
  formData.append('file', file);

  return axios.post('/api/onboarding/documents', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

/**
 * Видалення завантаженого документа
 * @param {string} key - ключ документа (docKey)
 */
export function deleteOnboardingDocument(key) {
  return axios({
    url: `/api/onboarding/documents/${key}`,
    method: 'delete',
  });
}


export function getOnboardingDocumentPages(docKey, data) {
  return axios({
    url: `/api/onboarding/documents/${docKey}/document-pages`,
    method: 'get',
  });
}

export function uploadOnboardingDocumentPage(docKey, formData) {
  return axios.post(`/api/onboarding/documents/${docKey}/document-pages`, formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function deleteOnboardingDocumentPage(docKey, page) {
  return axios({
    url: `/api/onboarding/documents/${docKey}/document-pages/${page}`,
    method: 'delete',
  });
}

export function confirmOnboardingDocumentPages(docKey, data) {
  return axios({
    url: `/api/onboarding/documents/${docKey}/document-pages/confirm`,
    method: 'post',
    data: data
  });
}

export function checkOnboardingDocumentPagesStatus(docKey) {
  return axios({
    url: `/api/onboarding/documents/${docKey}/document-pages/status`,
    method: 'get',
  });
}




/**
 * Фінальна відправка заявки на перевірку
 */
export function submitOnboarding() {
  return axios({
    url: '/api/onboarding/submit',
    method: 'post',
  });
}

export function generateDocuments(data) {
  return axios({
    url: '/api/onboarding/documents/generateDocs',
    method: 'post',
  });
}

export function showExampleDocument(data) {
  return axios({
    url: '/api/onboarding/contract-template?download=0',
    method: 'get',
    responseType: 'blob',
  });
}

export function showDocumentFile(userId, docId, isSigned, isDownload) {
  return axios({
    url: `/api/onboarding/documents/show/${userId}?id=${docId}&userId=${userId}&signed=${isSigned ? 1 : 0}&isDownload=${isDownload}`,
    method: 'get',
    responseType: 'blob',
  });
}

export function getListDocuments(data) {
  return axios({
    url: '/api/onboarding/documents/list',
    method: 'get',
  });
}

// export function signDocument(data) {
//   return axios({
//     url: '/api/onboarding/documents/sign',
//     method: 'post',
//     data: data
//   });
// }
//
// export function signAllDocuments(documentIds) {
//   return axios({
//     url: '/api/onboarding/documents/signAll',
//     method: 'post',
//     data: documentIds
//   });
// }

export function getCARegistryList() {
  return axios({
    url: '/api/onboarding/ca-registries',
    method: 'get',
  });
}

export function signDocument(formData) {
  return axios.post('/api/onboarding/documents/sign', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function signAllDocuments(formData) {
  return axios.post('/api/onboarding/documents/signAll', formData, {
    headers: {
      'Content-Type': 'multipart/form-data',
    },
  });
}

export function completeOnboarding(data) {
  return axios({
    url: '/api/onboarding/complete',
    method: 'post',
    data: data
  });
}




